import { v4 as uuidv4 } from "uuid";
import { RequestModelInterface } from "@/service/models/request-model-interface";
import { XmlDocumentWrapper } from "@/utilities/xml-helpers/xml-document-wrapper";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { DrugCovariate } from "../../response/drug-model-detail/covariate/drug-covariate";

export class CovariateValue implements RequestModelInterface
{
    public uuid: string;

    public constructor(
        public id: string,
        public date: Date,
        public value: number,
        public unit: string,
        public type: DrugCovariate.Type,
        public nature: string|null, // TODO: actually required by the API but should be removed in the future
    )
    {
        this.uuid = uuidv4();
    }

    public static makeFromCovariateDefaults(covariate: DrugCovariate): CovariateValue
    {
        return new this(
            covariate.id,
            new Date(),
            covariate.covariateValue.value,
            covariate.unit,
            covariate.type,
            "continuous"
        );
    }

    public static makeFromCovariate(covariate: DrugCovariate, value: number, date: Date): CovariateValue
    {
        return new this(
            covariate.id,
            date,
            value,
            covariate.unit,
            covariate.type,
            "continuous"
        );
    }

    public getXml(doc: XmlDocumentWrapper): XmlElementWrapper
    {
        const element = doc.createElement("covariate");

        element.appendNewElement("covariateId", this.id);
        element.appendNewElement("date", this.date.toISOString());
        element.appendNewElement("value", this.value.toFixed());
        element.appendNewElement("unit", this.unit);
        element.appendNewElement("dataType", this.type);

        if (this.nature !== null) {
            element.appendNewElement("nature", this.nature);
        }

        return element;
    }

    public isAge(): boolean
    {
        return [
            DrugCovariate.Type.AGE_IN_DAYS,
            DrugCovariate.Type.AGE_IN_WEEKS,
            DrugCovariate.Type.AGE_IN_MONTHS,
            DrugCovariate.Type.AGE_IN_YEARS,
        ].includes(this.type);
    }
}
